module.exports = __webpack_public_path__ + "img/fresh-vegetable.af6dc6e8.jpg";